import * as React from 'react';

var _path, _g, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgAddAllowListed = function SvgAddAllowListed(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 80 80"
    }, props), /*#__PURE__*/ React.createElement("mask", {
        id: "mask0_66_24911",
        width: 80,
        height: 80,
        x: 0,
        y: 0,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "alpha"
        }
    }, _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#D9D9D9",
        d: "M0 0h80v80H0z"
    }))), _g || (_g = /*#__PURE__*/ React.createElement("g", {
        mask: "url(#mask0_66_24911)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint0_linear_66_24911)",
        fillOpacity: 0.16,
        d: "m28.615 65.282 4.526 7.68q.436.769 1.256 1.07.82.3 1.673-.051L44 70.436l7.993 3.545a2.1 2.1 0 0 0 1.61.06 2.28 2.28 0 0 0 1.256-1.06l4.609-7.699 8.775-1.763q.854-.166 1.35-.936t.458-1.621l-.91-8.783 5.75-6.64q.603-.603.602-1.54 0-.935-.602-1.538l-5.75-6.621.91-8.782q.039-.854-.458-1.622-.497-.77-1.35-.936l-8.775-1.763-4.61-7.718a2.28 2.28 0 0 0-1.255-1.06 2.1 2.1 0 0 0-1.61.06L44 17.564l-7.93-3.545q-.852-.353-1.673-.051-.82.3-1.256 1.07l-4.526 7.7-8.859 1.762q-.852.166-1.35.936-.496.769-.393 1.622l.846 8.782-5.75 6.621q-.603.603-.603 1.539t.603 1.538l5.75 6.641-.846 8.782q-.103.854.394 1.622.496.77 1.35.936z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint1_linear_66_24911)",
        d: "m29.14 68.962-4.525-7.68-8.859-1.763q-.852-.166-1.35-.936-.496-.77-.393-1.621l.846-8.783-5.75-6.64q-.603-.603-.603-1.54 0-.935.603-1.538l5.75-6.621-.846-8.782q-.103-.854.394-1.622.497-.77 1.35-.936l8.858-1.763 4.526-7.699q.436-.77 1.256-1.07t1.673.051L40 13.564l7.993-3.545a2.1 2.1 0 0 1 1.61-.06q.82.29 1.256 1.06l4.609 7.718 8.775 1.763q.854.166 1.35.936.497.769.458 1.622l-.91 8.782 5.75 6.621q.603.603.602 1.539 0 .936-.602 1.538l-5.75 6.641.91 8.782q.039.854-.458 1.622-.497.77-1.35.936l-8.775 1.763-4.61 7.699q-.435.77-1.255 1.06a2.1 2.1 0 0 1-1.61-.06L40 66.436l-7.93 3.545q-.852.353-1.673.051a2.33 2.33 0 0 1-1.256-1.07m2.2-1.571L40 63.833l8.782 3.558 5.199-8.141 9.43-2.244-.873-9.724L68.968 40l-6.43-7.32.872-9.79-9.43-2.14-5.236-8.141L40 16.167l-8.782-3.558-5.199 8.14-9.43 2.142.872 9.788L11.032 40l6.43 7.283-.872 9.763 9.43 2.205zm5.14-21.872-6.595-6.718a1.34 1.34 0 0 0-.936-.416q-.571-.032-.956.333-.512.448-.512.987t.512.987l6.866 6.846q.685.75 1.59.75.903 0 1.654-.75L52.07 33.654q.301-.366.334-.936.032-.57-.417-1a1.12 1.12 0 0 0-.894-.305 1.34 1.34 0 0 0-.875.388z"
    }))), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_66_24911",
        x1: 13.164,
        x2: 74.617,
        y1: 43.999,
        y2: 43.999,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint1_linear_66_24911",
        x1: 9.164,
        x2: 70.617,
        y1: 39.999,
        y2: 39.999,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })))));
};

export { SvgAddAllowListed as ReactComponent };
//# sourceMappingURL=AddAllowListed.svg.es.js.map
